import more7days from '@/functions/more7days'
export default function setMItem(bizId: string, value: string ) {
    const allTokens = localStorage.getItem('allTokens') ? JSON.parse(localStorage.getItem('allTokens')) : {}
    allTokens[bizId] = value
    console.log('bizId', bizId)
    console.log('value', value)
    localStorage.setItem('allTokens', JSON.stringify(allTokens))
    const miniTimeH5 = localStorage.getItem('deadTime') || 0
    const curTime = new Date().getTime()
    if (!miniTimeH5 || more7days(curTime, miniTimeH5)) {
        // 过期或者不存在，更新时间
        localStorage.setItem('deadTime', new Date().getTime() + '')
    }
}
